"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @uifabric/icons@6.5.4
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
var set_version_1 = require("@uifabric/set-version");
set_version_1.setVersion('@uifabric/icons', '6.5.4');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/~/@uifabric/icons/lib-commonjs/version.js
// module id = 1087
// module chunks = 0